"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordCtrl = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var services_1 = require("../../services");
var user_service_1 = require("../../services/user.service");
var ForgotPasswordCtrl = /** @class */ (function () {
    function ForgotPasswordCtrl() {
        this.loading = false;
        this.completedReset = false;
    }
    ForgotPasswordCtrl.prototype.requestPasswordReset = function (emailAddress) {
        var _this = this;
        this.setLoading(true);
        var normalizedEmailAddress = emailAddress.trim().toLowerCase();
        return user_service_1.UserMutator.requestPasswordReset(normalizedEmailAddress)
            .then(function () {
            _this.setLoading(false);
            _this.setCompletedReset(true);
        })
            .catch(function (e) {
            services_1.Logger.error(e);
            _this.setLoading(false);
        });
    };
    ForgotPasswordCtrl.prototype.isValidEmail = function (value) {
        if (typeof (value) !== 'string') {
            return false;
        }
        var emailAddress = value.trim();
        var firstIndex = emailAddress.indexOf('@');
        var lastIndex = emailAddress.lastIndexOf('@');
        return firstIndex > 0 &&
            firstIndex === lastIndex &&
            lastIndex < emailAddress.length - 1;
    };
    ForgotPasswordCtrl.prototype.setLoading = function (loading) {
        this.loading = loading;
    };
    ForgotPasswordCtrl.prototype.setCompletedReset = function (completed) {
        this.completedReset = completed;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], ForgotPasswordCtrl.prototype, "loading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ForgotPasswordCtrl.prototype, "completedReset", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ForgotPasswordCtrl.prototype, "setLoading", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ForgotPasswordCtrl.prototype, "setCompletedReset", null);
    return ForgotPasswordCtrl;
}());
exports.ForgotPasswordCtrl = ForgotPasswordCtrl;
//# sourceMappingURL=forgot.password.ctrl.js.map